export default __webpack_public_path__ + "static/media/zine-itch-article2.282324ea.png";